<template>
    <div class="@container/timerange">
        <div class="time-range-picker flex flex-col gap-2.5 @2xl/timerange:grid grid-cols-[160px_1fr_auto]">
            <div>
                <vx-selectable
                    v-model="model.day"
                    :clearable="false"
                    placeholder="Select Week Day"
                    :reduce="(option) => option.value"
                    :options="[
                        { label: 'Sunday', value: 0 },
                        { label: 'Monday', value: 1 },
                        { label: 'Tuesday', value: 2 },
                        { label: 'Wednesday', value: 3 },
                        { label: 'Thursday', value: 4 },
                        { label: 'Friday', value: 5 },
                        { label: 'Saturday', value: 6 },
                    ]"
                ></vx-selectable>
            </div>

            <div
                class="grid grid-cols-[auto_1fr] @md/timerange:grid-cols-[auto_1fr_auto_1fr] items-center gap-2"
            >
                <div>From</div>
                <vx-date-picker
                    size="sm"
                    v-model="from"
                    mode="time"
                ></vx-date-picker>

                <div>To<span v-if="wrapsNextDay" class="ml-1 text-xs text-slate-500">(next day)</span></div>
                <vx-date-picker size="sm" v-model="to" mode="time"></vx-date-picker>
            </div>

            <div class="flex gap-2">
                <vx-button
                    @click.prevent="emit('add')"
                    type="button"
                    color="muted-light"
                    class="grow"
                >
                    <font-awesome-icon widthAuto :icon="faPlus"></font-awesome-icon>
                </vx-button>
                <vx-button
                    @click.prevent="emit('remove')"
                    type="button"
                    color="muted-light"
                >
                    <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
                </vx-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    VxButton,
    VxSelectable,
    VxDatePicker,
} from '@voxie/frontend-components';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPlus, faTrash } from "@fortawesome/pro-solid-svg-icons";
import { computed } from "vue";
import dayjs from "~/utils/dayjs";

const model = defineModel();
const emit = defineEmits(["remove", "add"]);

const from = computed({
    set: (date) => {
        model.value.from = dayjs(date).format("HH:mm");
    },
    get: () => {
        return dayjs("2024-05-03 " + model.value.from).toDate();
    },
});

const to = computed({
    set: (date) => {
        model.value.to = dayjs(date).format("HH:mm");
    },
    get: () => {
        return dayjs("2024-05-03 " + model.value.to).toDate();
    },
});

const wrapsNextDay = computed(() => {
    return model.value.from > model.value.to;
});
</script>

<style scoped>
.time-range-picker :deep(.vx-date-picker.vx-date-picker--sm),
.time-range-picker :deep(.vc-time-picker) {
    width: 100%;
}
.vx-date-picker.vx-date-picker--sm :deep(.vc-time-picker) {
    width: 100%;
}
.vx-date-picker :deep(.vc-time-select-group) {
    gap: 2px;
    padding: 0;
    margin: 0;
}
</style>
